exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-sm-label[data-v-7e92e542]{\n    font-size: 12px;\n}\n.checkbox__label[data-v-7e92e542]::after {\n    background-color: #78be20 !important;\n}\n", ""]);

// exports
